import * as React from "react";
import { LayoutComponent } from "../LayoutComponent";
import { Item, TabList, TabPanels, Tabs, View } from "@adobe/react-spectrum";
import { LayoutDefinition } from "../../../../infra/protected/Layout/LayoutDefinitions";
import { ComponentFactory } from "../ComponentFactory";
import { FPAData } from "../../../../infra/protected/FPA/FPAData";
import { SystemAttributes } from "../../../../infra/protected/Layout/SystemAttributes";

export interface ITabsLayoutProps {
    selectedItem?: FPAData;
    children?: LayoutDefinition[];
    systemAttributes: SystemAttributes<FPAData>;
}

function TabsLayout({ selectedItem, children, systemAttributes }: ITabsLayoutProps) {
    if(!children || children.length === 0) return (<>No children</>);
    return (
        <View>
            <Tabs aria-label="Tabs Layout" isEmphasized>
                <TabList UNSAFE_style={{ overflowX: "auto", maxWidth: "93vw" }}>
                    {children.map((child, index) => (<Item key={`item_${index}`}>{child.name}</Item>))}
                </TabList>
                <TabPanels>
                    {children.map((child, index) => (<Item key={`item_${index}`}>
                        <ComponentFactory selectedItem={selectedItem!} definition={child} systemAttributes={systemAttributes} />
                    </Item>))}
                </TabPanels>
            </Tabs>
        </View>
    );
}

export const TabsLayoutComponent = LayoutComponent<ITabsLayoutProps>(TabsLayout);
